import React, { useContext, useState } from "react";

// MUI Components
import { ExpandLess, ExpandMore, RouteOutlined, SettingsInputComposite } from "@mui/icons-material";
import { Box, Button, Menu, MenuItem, Typography } from "@mui/material";

// AWS Components
import { DataStore } from "aws-amplify";
import { Streams } from "../../models";

// Gray Componets
import setActivityLog from "../../utilities/setActivityLog";
import { Application } from "../../context/Application";
import { getInputs } from "../../utilities/utility";

const AdminInputSource = ({ streamData, forceUpdate }) => {
  const global = useContext(Application);

  /* Drop Down Elements */
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  /* Admin Tool - Set Stream as Primary for ActiveSB */
  const setInput = async (data, config) => {
    const original = await DataStore.query(Streams, (c) =>
      c.and((c) => [c.ssid.eq(+data.ssid), c.station.eq(data.sname.toLowerCase().replace(/-\D\D/, ""))])
    );

    try {
      if (original.length > 0 && original[0].hasOwnProperty("ssid")) {
        /* Update Record */
        console.log(
          await DataStore.save(
            Streams.copyOf(original[0], (updated) => {
              updated.input = config;
              updated.author = global.appUser.email;
            })
          )
        );
      } else {
        /* Create Record */
        console.log(
          await DataStore.save(
            new Streams({
              station: data.sname.toLowerCase().replace(/-\D\D/, ""),
              ssid: +data.ssid,
              activesb: data.activesb,
              input: config,
              author: global.appUser.email,
            })
          )
        );
      }

      await setActivityLog({
        type: "INPUTS",
        note: `Stream input set to ${config} for #${+data.ssid}`,
        author: global.appUser.email,
        station: global.activeStation.station,
      });

      // Refresh Navigation
      forceUpdate();
    } catch (e) {
      console.log("   - ERROR", e);
    }
  };
  return (
    <Box className="admin___panel_button">
      <Box className="title">
        <SettingsInputComposite fontSize="1rem" />
        <Typography>Input Source</Typography>
      </Box>
      <Box className="description">
        <Typography>
          Define the input source for <b>{streamData.friendly}</b> to help streamline troubleshooting issues.
        </Typography>

        <Typography>
          <b>NOTE:</b> Administrator can still view all streams regardless of visibility setting.
        </Typography>
      </Box>
      <Box className="status">
        <Button
          id="input-source-button"
          variant="outlined"
          aria-controls={open ? "input-source-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
          endIcon={open ? <ExpandLess /> : <ExpandMore />}
          size="small"
        >
          {open ? "Select Input ..." : streamData.input ? getInputs(streamData.input) : "Select Input"}
        </Button>
        <Menu
          id="input-source-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          {[
            { value: "SOURCE1", name: "Source 1" },
            { value: "SOURCE2", name: "Source 2" },
            { value: "OTHER", name: "Undefined" },
          ].map((item, key) => {
            return (
              <MenuItem
                key={item.value}
                onClick={() => {
                  handleClose();
                  setInput(streamData, item.value);
                }}
                sx={{
                  minWidth: "16.25rem",
                  fontSize: "0.875rem",
                  fontWeight: streamData?.input === item.value ? 700 : "inherit",
                  color: streamData?.input === item.value ? "rgba(15, 72, 255, 0.75)" : "inherit",
                }}
              >
                {item.name}
              </MenuItem>
            );
          })}
        </Menu>
      </Box>
    </Box>
  );
};

export default React.memo(AdminInputSource);
